import React, { useState, useContext, useEffect } from "react";
import "../../css/home/home.css"; // Asegúrate de crear este archivo CSS también
import Logo from "../../assets/logos/LogoColurs.png";
import { UtilContext } from "../../context/UtilContext"; // Asegúrate de importar el contexto correcto
import NavbarRegistro from "../../components/navbar/NavbarRegistro";
import { AuthContext } from '../../context/AuthContext';
import { useNavigate, useLocation } from "react-router-dom";
import { GLOBAL_LANGUAGE } from "../../language/language";
import axios from "axios";


const DocumentationComplete = () => {

    const { language } = useContext(UtilContext); // Usa el contexto de Auth
    const t = GLOBAL_LANGUAGE[language] || GLOBAL_LANGUAGE.es;


    const { logout, getAuthenticatedHeaders } = useContext(AuthContext);
    const navigate = useNavigate();
    const [DetailUser, setDetailUser] = useState(null)
    const fetchUserDetails = async () => {
        try {
            const response = await axios.post(`/api/user`, {
                headers: await getAuthenticatedHeaders(),
            });

            if (response?.data?.data && typeof response.data.data === 'object') {
                localStorage.setItem('userDetails', JSON.stringify(response.data.data));

            } else {
                console.warn("Datos de usuario inválidos, no se guardarán en localStorage.");
            }

            // Redirige al dashboard después de que el progreso llegue al 100%
        } catch (error) {
            console.error("Error al obtener los datos del usuario:", error);
        }
    };

    useEffect(() => {


        if (DetailUser !== null) {

            if (DetailUser.document_status === "APPROVED") {
                navigate("/splash", { state: { DetailUser: DetailUser } })
            }
            if (DetailUser.document_status === "INITIAL") {
                navigate("/bienvenido", { state: { DetailUser: DetailUser } })
            }
            if (DetailUser.document_status === "PENDING") {
                navigate("/documentacion-legal", { state: { DetailUser: DetailUser } })
            }

        }

    }, [DetailUser])
    useEffect(() => {
        fetchUserDetails()
    }, [])

    return (
        <div className="w-full flex flex-col  bg-[#1B1B22] h-[100vh] " >
            <div className=" py-5 px-11 bg-[#1B1B22] ">
                <NavbarRegistro onClose={logout} />
            </div>
            <div className="w-full h-[100vh] flex items-center justify-center " >
                <div className="w-[550px] h-[40vh] flex items-center text-center flex-col justify-center gap-4 " >
                    <img src={Logo} style={{ width: 52, height: 52 }}></img>
                    <div>
                        <h2 className=" text-2xl mt-8 text-white " style={{ fontFamily: "brico" }} >{t.banned.title}</h2>
                        <p className='text-[#B7B7B9]'>{t.banned.title}</p>
                    </div>


                    <p className='text-[#B7B7B9]'>{t.banned.title}<a href="https://colurs.odoo.com/" target="_blanck" className='text-[#ffffff] underline ' >{t.banned.title}</a></p>
                </div>
            </div>
        </div>
    );
};

export default DocumentationComplete;
